import React, { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import BackgroundImage from "/Images/Background.svg";
import Bapepti from "/Images/Mask group.svg";
import Kominfo from "/Images/Mask group (1).svg";
import AboutUs from "/Images/teams.png"; // Import the new image
import "../Components/HeroTransition.css"; // Import CSS file

const assets = [
  { text: "digital assets", color: "#F4E37B" },
  { text: "blockchain investments", color: "#A1D6E2" },
  { text: "tokenized assets", color: "#FF6B6B" },
];

const HeroSection = () => {
  const [currentAssetIndex, setCurrentAssetIndex] = useState(0);
  const isMobile = useMediaQuery("(max-width: 767px)"); // Media query check

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAssetIndex((prevIndex) => (prevIndex + 1) % assets.length);
    }, 2000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [currentAssetIndex]);

  const styles = {
    button: {
      backgroundColor: "#F4E37B",
      color: "#214D73",
      padding: isMobile ? "10px 20px" : "15px 30px",
      borderRadius: "8px",
      border: "none",
      fontSize: isMobile ? "0.875rem" : "1rem",
      cursor: "pointer",
      textDecoration: "none",
      display: "inline-block",
      marginTop: "30px",
    },
  };

  return (
    <section
      style={{
        position: "relative",
        width: "100%",
        minHeight: isMobile ? "450px" : "820px",
        overflow: "hidden",
      }}
    >
      {/* Background Image */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${BackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: -1,
        }}
      />

      {/* Content Container */}
      <div
        style={{
          padding: isMobile ? "0 2.5rem" : "0 6rem",
          paddingTop: isMobile ? "6rem" : "16rem",
          paddingBottom: isMobile ? "8rem" : "8rem",
          color: "#FFFFFF",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "left",
          justifyContent: "space-between",
          zIndex: 1, // Ensure it is above the background
        }}
      >
        {/* Left Content */}
        <div
          style={{
            flex: 1,
            paddingRight: isMobile ? "0" : "3rem",
            textAlign: "left",
            minWidth: isMobile ? "auto" : "750px",
            marginTop: isMobile ? "auto" : "50px",
          }}
        >
          {/* Main Heading */}
          <h1
            style={{
              fontSize: isMobile ? "24px" : "50px",
              fontWeight: 550,
              lineHeight: "1.2",
              marginBottom: isMobile ? "20px" : "50px",
            }}
          >
            <span> Reaching a Billion People </span> <br />
            with <span style={{ color: "#F4E37B" }}> Blockchain Innovation</span>
            <br />
          </h1>

          {/* Subtitle */}
          <p
            style={{
              fontSize: isMobile ? "14px" : "22px",
              color: "#E7E4E2",
              marginBottom: isMobile ? "30px" : "80px",
              maxWidth: isMobile ? "100%" : "762px",
            }}
          >
            We’re here to deliver tailored blockchain solutions for your needs,
            empowering you with secure and innovative technology.
          </p>

          {/* License Information */}

        </div>

        {/* Right Image */}
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: isMobile ? "2rem" : "0",
          }}
        >
          <img
            src={AboutUs}
            alt="About Us"
            style={{
              minWidth: isMobile ? "70%" : "500px",
              height: isMobile ? "auto" : "420px",
              filter: "drop-shadow(1px 1px 8px rgba(0, 0, 0, 0.5))",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
